import axios from 'axios';
import domain from '@/environment';
const state = {
  loadingRecapCommerciaux: false,
  allDepotRecapCommerciaux: [],
  recapCommerciaux: []
};
const getters = {
  getLoadingRecapCommerciaux: state => state.loadingRecapCommerciaux,
  getAllDepotRecapCommerciaux: state => state.allDepotRecapCommerciaux,
  getRecapCommerciaux: state => state.recapCommerciaux
};
const mutations = {
  SET_LOADING_RECAP_COMMERCIAUX(satate, payload) {
    state.loadingRecapCommerciaux = payload;
  },
  SET_All_DEPOT_RECAP(state, payload) {
    state.allDepotRecapCommerciaux = payload;
  },
  SET_RECAP_COMMERCIAUX(state, payload) {
    if (payload.reset && payload.reset == true) {
      state.recapCommerciaux = [];
    } else {
      let table = [];
      Object.entries(payload).map(([key, value]) => {
        table.push({ depot: key, value: value });
      });
      state.recapCommerciaux = [...table];
    }
  }
};
const actions = {
  async fetchAllDepotRecapCommerciaux({ commit }, payload) {
    commit('SET_LOADING_RECAP_COMMERCIAUX', true);
    const params = { year: payload.year };
    if (payload.switchMonth && payload.switchMonth == true) {
      params.month = payload.month;
    } else {
      if (payload.semaine != null) {
        params.semaine = payload.semaine;
      }
    }
    try {
      const response = await axios.get(domain + `/api/allDepots`, {
        params: params,
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        }
      });
      commit('SET_All_DEPOT_RECAP', response.data.data);
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);

      return true;
    } catch (error) {
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);
      return false;
    }
  },
  async getRecapCommerciauxFiltred({ commit, state }, payload) {
    commit('SET_LOADING_RECAP_COMMERCIAUX', true);
    const params = { year: payload.year, type: payload.type };
    if (payload.switchMonth && payload.switchMonth == true) {
      params.month = payload.month;
    } else {
      if (payload.semaine != null) {
        params.semaine = payload.semaine;
      }
    }
    if (payload.depot && payload.depot.id == null) {
      params.depot = state.allDepotRecapCommerciaux;
    }
    if (payload.depot && payload.depot.id != null) {
      params.depot = [];
      params.depot.push(payload.depot.id);
    }
    try {
      const response = await axios.get(domain + `/api/BillsPerDepot`, {
        params: params,
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        }
      });
      commit('SET_RECAP_COMMERCIAUX', response.data.data);
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);

      return true;
    } catch (error) {
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);
      return false;
    }
  },
  async exportExcelRecapCommerciaux({ commit }, payload) {
    commit('SET_LOADING_RECAP_COMMERCIAUX', true);
    const params = { year: payload.year, type: payload.type };
    if (payload.switchMonth && payload.switchMonth == true) {
      params.month = payload.month;
    } else {
      if (payload.semaine != null) {
        params.semaine = payload.semaine;
      }
    }
    if (payload.depot && payload.depot.id == null) {
      if (state.allDepotRecapCommerciaux.length == 0) {
        commit('SET_LOADING_RECAP_COMMERCIAUX', false);
        return;
      }
      params.depot = state.allDepotRecapCommerciaux;
    }
    if (payload.depot && payload.depot.id != null) {
      params.depot = [];
      params.depot.push(payload.depot.id);
    }
    try {
      const response = await axios.get(domain + `/api/exportBillsPerDepot`, {
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        }
      });
      const name =
        payload.switchMonth && payload.switchMonth == true
          ? 'M' + payload.month
          : payload.semaine;
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute(
        'download',
        'RECAP COMMERCIAUX - ' + name + ' ' + payload.year + '.xlsx'
      );
      document.body.appendChild(link);
      link.click();
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);
      return true;
    } catch (error) {
      commit('SET_LOADING_RECAP_COMMERCIAUX', false);
      return false;
    }
  },
  resetRecapCommerciaux({ commit }) {
    commit('SET_RECAP_COMMERCIAUX', { reset: true });
  }
};
export default {
  state,
  getters,
  mutations,
  actions
};
